import { createFeatureSelector } from '@ngrx/store';
import { ADVOCACY_GROUP_FEATURE, AdvocacyGroupState } from './advocacy-group.reducers';

export const selectAdvocacyGroupFeature =
  createFeatureSelector<AdvocacyGroupState>(ADVOCACY_GROUP_FEATURE);
